import React, { useEffect, useState } from "react";
import { Grid, IconButton, Button } from "@material-ui/core";
import RouteOption from "./RouteOption";
import AirportsLookup from "../../Airports/components/AirportsLookup";
import { Flight, LocalShipping } from "@material-ui/icons";
import { calculateOptionForRoute } from "../includes/calculateOptimalRoute";
import __ from "lodash";
import { FormDialog } from "../../../controls";

const emptyRecord = {
  airport0: "",
  airport1: "",
  airport2: "",
  airport3: "",
  airport4: "",
  airport5: "",
  airport6: "",
  airport7: "",
  origin0: "",
  origin1: "",
  origin2: "",
  origin3: "",
  destination0: "",
  destination1: "",
  destination2: "",
  destination3: "",
  otherRouteType0: "",
  otherRouteType1: "",
  otherRouteType2: "",
  otherRouteType3: "",
  option: null
}

const QuickRoute = (props) => {
  const {SystemData} = props;
  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    status: '',
    progress: null,
    aircraftTailNumber: '',
    cargo: [],
    sectors: [],
  });

  useEffect(()=> {
    const open = async (params) => {
      setDialogState(
        {
          ...dialogState,
          showDialog:true,
          status: params?.status||'',
          aircraftTailNumber: params?.aircraftTailNumber||'',
          cargo: params?.cargo||[],
          sectors: params?.sectors||[],
        }
      );
    }
    eventBus.bind("QuickRoute.open", open);

    return () => {
      eventBus.unbind("QuickRoute.open", open);
    }
  }, [dialogState, eventBus]);

  const handleSave = (option, otherRoutes) => {
    if (!__.has(props, "legs") || (props.legs && Array.isArray(props.legs) && props.legs.length > 0)) {
      SystemData.confirm(
        "Quick Route",
        `Please note continuing will remove all legs, costing and revenue data, do you wish to continue?`,
        [
          {icon: "check_circle_outline", value: true, label: "Yes", options: {color:"primary"}},
          {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
        ],
        (response) => {
          if (response) {
            if (props.onChange) {
              props.onChange({option, otherRoutes});
            }
            setDialogState({...dialogState, showDialog: false, status: "", aircraftTailNumber: '', cargo: [], sectors: [], record: {...__.cloneDeep(emptyRecord)}});
          }
        }
      );
    } else {
      if (props.onChange) {
        props.onChange({option, otherRoutes});
      }
      setDialogState({...dialogState, showDialog: false, status: "", aircraftTailNumber: '', cargo: [], sectors: [], record: {...__.cloneDeep(emptyRecord)}});
    }
  }

  const handleClose = () => {
    setDialogState({...dialogState, showDialog: false, options: null, status: "", aircraftTailNumber: '', cargo: [], sectors: [], record: {...__.cloneDeep(emptyRecord)}});
  }

  const setAirport = async (i, airport, formProps) => {
    const {onChange, recordChange, record} = formProps;
    const newRecord = {...record, [`airport${i}`]: airport};
    let route = [];
    let calc = true;
    for (let ii = 0; ii < 8; ii++) {
      const airport = newRecord[`airport${ii}`];
      if (airport) {
        route.push(airport);
        if (airport.length < 3) calc = false;
      }
    }
    if (route && route.length > 0 && calc) {
      const routeOption = await calculateOptionForRoute(dialogState.aircraftTailNumber, dialogState.cargo, props.queryClient, route);
      newRecord['option'] = routeOption;
    } else {
      newRecord['option'] = null;
    }
    recordChange(newRecord);
  }

  if (dialogState.showDialog) {
    return (
      <FormDialog
        open={dialogState.showDialog}
        title="Quick Routes"
        message="Please enter the desired route below, please note saving the route will remove all legs, costing and revenue data:"
        dialogOptions={{maxWidth: "lg", fullWidth: true }}
        buttons={{
          save:{icon: "save", key: "Save", label: "Save", color: "primary"},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        record={{...__.cloneDeep(emptyRecord)}}
        onChange={(state) => {
          if (state.buttonPressed === "cancel") {
            handleClose();
          }
          if (state.buttonPressed === "save") {
            const {option} = state.record;
            handleSave(option);
          }
        }}
      maxWidth={770}
      >
        <div style={{display: 'block', width: '100%'}}>
          <Grid container checkChildren={true} spacing={2}>
            <Grid item xs={12}>
              <h3>Route</h3>
            </Grid>
            <Grid item checkChildren={true} style={{width: 110}}>
              <AirportsLookup id="airport0" disableClearable={false} onChange={(value, props) => {setAirport(0, value, props)}}/>
            </Grid>
            <Grid item checkChildren={true} style={{width: 110}}>
              <AirportsLookup id="airport1" disableClearable={false} onChange={(value, props) => {setAirport(1, value, props)}}/>
            </Grid>
            <Grid item checkChildren={true} style={{width: 110}}>
              <AirportsLookup id="airport2" disableClearable={false} onChange={(value, props) => {setAirport(2, value, props)}}/>
            </Grid>
            <Grid item checkChildren={true} style={{width: 110}}>
              <AirportsLookup id="airport3" disableClearable={false} onChange={(value, props) => {setAirport(3, value, props)}}/>
            </Grid>
            <Grid item checkChildren={true} style={{width: 110}}>
              <AirportsLookup id="airport4" disableClearable={false} onChange={(value, props) => {setAirport(4, value, props)}}/>
            </Grid>
            <Grid item checkChildren={true} style={{width: 110}}>
              <AirportsLookup id="airport5" disableClearable={false} onChange={(value, props) => {setAirport(5, value, props)}}/>
            </Grid>
            <Grid item checkChildren={true} style={{width: 110}}>
              <AirportsLookup id="airport6" disableClearable={false} onChange={(value, props) => {setAirport(6, value, props)}}/>
            </Grid>
            <Grid item checkChildren={true} style={{width: 110}}>
              <AirportsLookup id="airport7" disableClearable={false} onChange={(value, props) => {setAirport(7, value, props)}}/>
            </Grid>
          </Grid>
          {/* <Grid container checkChildren={true} spacing={2}>
            <Grid item xs={12}>
              <h3>Other Routes</h3>
            </Grid>
            <Grid item xs={3} checkChildren={true}>
              <div style={{display: "inline-block", width: 110}}>
                <AirportsLookup id="origin0" disableClearable={false} />
              </div>
              {(record, changeRecord) => {debugger; return (
                <div style={{display: "inline-block"}}>
                  <IconButton id="otherRouteType0" onClick={(e) => {
                    debugger;
                      const newValue = record.otherRouteType0 === 'truck' ? 'aircraft' : "truck";
                      changeRecord({...record, otherRouteType0:newValue});
                    }}>
                      {record.otherRouteType0 === 'truck' ? <LocalShipping /> : <Flight />}
                  </IconButton>
                </div>
              )}}
              <div style={{display: "inline-block", width: 110}}>
                <AirportsLookup id="destination0" disableClearable={false} />
              </div>
            </Grid>

          </Grid> */}
          <div>
            {record => {if (record && record.option && record.option !== null){
              return (
                <RouteOption option={record.option}/>
              )
            } else {
              return (<div style={{minHeight: 301.25}}/>)
            }}}
          </div>
        </div>
      </FormDialog>
    );
  }
  return null;
}

export default QuickRoute;
